define('MysqlDatetimeFormat',[],function(){
    //
    // converti une date formatée par Mysql YYYY-MM-DD HH:mm:ss
    // en Date JS
    //
    return function(datetime) {
        var datetimeExp = /\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/g,
            test = datetimeExp.test(datetime);
        if(!test){
            throw new Error('Invalid Datetime : '+datetime);
        }
        return new Date(datetime.replace(/-/g,'/'))
    }
});
